const CustomCard = ({ children }) => (
  <div className="bg-bg2-pattern dark:bg-bg2-pattern2 md:mx-10 xl:mx-[7.5rem] mx-5 lg:my-16 my-8 text-[#25346A] dark:text-white bg-cover bg-center lg:p-10 p-5 lg:text-[20px] text-sm text-center font-semibold rounded-[20px] border-2 border-[#25346A1A] lg:leading-9 leading-6">
    {children}
  </div>
);

export default CustomCard;
